import React from "react";
import PlusButton from "../buttons/PlusButton";

import "./MovieArtistDesc.scss";

const MovieArtistDesc = ({ artistName }) => {
  return (
    <div className="artist-desc-container">
      <div className="artist-desc-container__plus-btn">
        <PlusButton />
      </div>
      <div className="artist-desc-container__desc">
        <div className="artist-desc-container__name">{artistName}</div>
        <div className="artist-desc-container__movies">+22 Movies</div>
        <div className="artist-desc-container__stars">⭐⭐⭐⭐</div>
      </div>
    </div>
  );
};
export default MovieArtistDesc;
